import React from "react";
import TextField from "@material-ui/core/TextField";
import { useInput } from "react-admin";

const TimeInput = (props) => {
  const {
    input,
    meta: { touched, error },
    isRequired
  } = useInput(props);
  return (
    <TextField
      id="time"
      label={props.label}
      type="time"
      error={!!(touched && error)}
      helperText={touched && error}
      required={isRequired}
      variant="filled"
      InputLabelProps={{
        shrink: true
      }}
      {...input}
    />
  );
};

export default TimeInput;
